import { useIntl } from "react-intl";

import { CurrencyInput } from "@/components/Inputs/CurrencyInput";
import { Slider, type SliderProps } from "@/components/Sliders/Slider";
import { formatCurrency } from "@/utils/currency";

type Props = SliderProps & {
  descale?: (value: number) => number;
};

export const PriceRangeSlider = ({
  min,
  max,
  value,
  onChange,
  scale,
  descale,
  ...props
}: Props) => {
  const intl = useIntl();

  const scaledMin = scale ? scale(min) : min;
  const scaledMax = scale ? scale(max) : max;
  const scaledCurrentMin = scale ? scale(value[0]) : value[0];
  const scaledCurrentMax = scale ? scale(value[1]) : value[1];

  return (
    <>
      <div className="overflow-x-clip px-2">
        <Slider
          {...props}
          min={min}
          max={max}
          onChange={onChange}
          value={value}
          valueLabelFormat={(value) => formatCurrency(value)}
          scale={scale}
        />
      </div>

      <div className="flex gap-6">
        <CurrencyInput
          min={scaledMin}
          max={scaledCurrentMax}
          label={intl.formatMessage({
            defaultMessage: "Min Price",
            description: "Lower bound label for a price range filter",
          })}
          value={scaledCurrentMin}
          onChange={(newMin) => {
            const minValue = descale ? descale(newMin) : newMin;
            const maxValue = value[1];
            onChange([minValue, maxValue]);
          }}
        />

        <CurrencyInput
          min={scaledCurrentMin}
          max={scaledMax}
          label={intl.formatMessage({
            defaultMessage: "Max Price",
            description: "Upper bound label for a price range filter",
          })}
          value={scaledCurrentMax}
          onChange={(newMax) => {
            const minValue = value[0];
            const maxValue = descale ? descale(newMax) : newMax;
            onChange([minValue, maxValue]);
          }}
        />
      </div>
    </>
  );
};
